<script>

import headerDefault from "@/components/App/header-default/header-default.vue";
import ticker from "@/components/App/ticker.vue";
import footerDefault from "@/components/App/footer/footer.vue";

export default {
    name: "default-page",
    components: {footerDefault, ticker, headerDefault},
    props: {
        page: {
            type: Object,
            required: true
        }
    }
}
</script>

<template>
    <div class="silver-background">
        <ticker></ticker>
        <header-default></header-default>
        <div class="container page column-page">
            <h2 class="page-header">{{ page["Заголовок"] }}</h2>
            <div v-html="page['Текст']"></div>
        </div>
    </div>
    <footer-default></footer-default>
</template>

<style scoped lang="scss">
    h2.page-header {
        font-size: 34px;
        font-weight: 600;
        line-height: 110%;
        margin-bottom: 20px;
    }

    @media screen and (max-width: 750px) {
        h2.page-header {
            font-size: 28px;
        }

        p {
            font-size: 14px;
        }
    }
</style>

<style lang="scss">

.row:last-child {
    margin-bottom: 0 !important;
}

div.col h5 {
    margin-bottom: 20px;
}

div.ol, div.descr {
    padding: 0 20px;
}

div.descr {
    margin-bottom: 10px;
}

div.li {
    font-size: 16px;
}

div.li:not(:last-child) {
    margin-bottom: 10px;
}

@media screen and (max-width: 750px) {
    div.col h5 {
        margin-bottom: 15px;
    }

    div.ol, div.descr {
        padding: 0 15px;
    }

    div.li, div.descr {
        font-size: 14px;
    }
}

</style>